<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="level1-front5">
<a href="#/front03">Epigraph</a>
</li>
<li id="level1-front6">
<a href="#/front04">Introduction</a>
</li>
<li id="c01">
<a href="#/c01">The Opening Bell</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">The Seduction</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">The Secrets of Brazilian Jiu-Jitsu</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">Birth of UFC Nation</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Battle of the Masters</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Fighting Solves Everything</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">The Cult of Pat</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Defending the Belt</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">Great Dana</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Rematch? What Rematch?</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">The Heavyweight’s Heavyweight</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">Tuf Enough</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">The MMA Godfather</span>
</li>
<li id="c14">
<span href="#/c14" title="Link target outside of Sample">King of Pain</span>
</li>
<li id="c15">
<span href="#/c15" title="Link target outside of Sample">The Final Round</span>
</li>
<li id="level1-back22">
<span href="#/back01" title="Link target outside of Sample">Glossary</span>
</li>
<li id="level1-back23">
<span href="#/back02" title="Link target outside of Sample">Ultimate Fighting Championship Rules</span>
</li>
<li id="level1-back24">
<span href="#/back03" title="Link target outside of Sample">Acknowledgments</span>
</li>
<li id="level1-footnotes">
<span href="#/footnotes" title="Link target outside of Sample">Footnotes</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a5cb48ac